import { STUDIO_SEARCH_DEFAULT_SORT_BY } from 'constants/app';
import { isEqual } from 'lodash';
import { AppDispatch, Store } from 'store';
import prepareCategoryFilters from 'utils/family/prepareCategoryFilters';
import parseStudioSearchPageParamsServer from 'utils/routes/parseStudioSearchPageParamsServer';
import sanitiseXSS from 'utils/sanitiseXSS';
import getStudioSearchFilters from '../selector/getStudioSearchFilters';
import getStudioSearchPageNr from '../selector/getStudioSearchPageNr';
import getStudioSearchQuery from '../selector/getStudioSearchQuery';
import getStudioSearchSortBy from '../selector/getStudioSearchSortBy';
import {
  setStudioSearchFiltersSelectionAction,
  setStudioSearchPageNrAction,
  setStudioSearchQueryAction,
  setStudioSearchSortByAction,
} from '../slice';
import fetchStudioSearchResultsOperation from './fetchStudioSearchResultsOperation';
import { filtersFromQueryString } from './setStudioSearchFiltersSelectionPHPWayOperation';

const setParamsFromQueryStringOperation =
  (queryString: URLSearchParams | any, fetchData = true) =>
  async (dispatch: AppDispatch, getState: () => Store) => {
    const store = getState();
    const currentPageNr = getStudioSearchPageNr(store);
    const currentSortBy = getStudioSearchSortBy(store);
    const currentQuery = getStudioSearchQuery(store);
    const currentFilters = getStudioSearchFilters(store);

    let { pageNr, sortBy, query } = parseStudioSearchPageParamsServer(queryString);
    const studioSearchFiltersFromURL = filtersFromQueryString(queryString);

    pageNr = pageNr || 1;
    sortBy = sortBy || STUDIO_SEARCH_DEFAULT_SORT_BY;

    pageNr *= 1;
    sortBy = sanitiseXSS(sortBy);
    query = sanitiseXSS(query);

    if (currentSortBy !== sortBy) dispatch(setStudioSearchSortByAction(sortBy));
    if (currentPageNr !== pageNr) dispatch(setStudioSearchPageNrAction(pageNr));
    if (currentQuery !== query) {
      dispatch(setStudioSearchQueryAction(query));
    }

    if (!isEqual(prepareCategoryFilters(currentFilters), prepareCategoryFilters(studioSearchFiltersFromURL))) {
      dispatch(setStudioSearchFiltersSelectionAction(studioSearchFiltersFromURL));
    }
    if (fetchData) {
      await dispatch(fetchStudioSearchResultsOperation());
    }
  };

export default setParamsFromQueryStringOperation;
